module.exports = "<svg width=\"23\" height=\"18\" viewBox=\"0 0 23 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.09833 7.71429L0 12.8571L5.09833 18V14.1429H14.0556V11.5714H5.09833V7.71429ZM23 5.14286L17.9017 0V3.85714H8.94444V6.42857H17.9017V10.2857L23 5.14286Z\" fill=\"white\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/switch.svg
// module id = 879
// module chunks = 0